import { AppState } from './../../../interfaces';
import { connect } from 'react-redux';
import Footer from './Footer';

const mapStateToProps = (state: AppState) => {
  return {
    appWidth: state.uiReducer.appWidth,
    appConfig: state.appReducer.config,
  };
};

export default connect(mapStateToProps, null)(Footer);
